import { Component, OnInit } from '@angular/core';
import { ObjectLayoutWidget } from 'ngx-schema-form';


@Component({
    selector: 'sf-demo-wizard-widget',
    templateUrl: './wizard.widget.html',
    styleUrls: ['./wizard.widget.css'],
})

export class WizardWidget extends ObjectLayoutWidget implements OnInit {

    currentPage = null;


    ngOnInit() {
        this.currentPage = 0;
    }

    nextPage() {
        if (this.hasNextPage()) {
            ++this.currentPage;
        }
    }

    previousPage() {
        if (this.currentPage > 0) {
            --this.currentPage;
        }
    }

    hasPreviousPage() {
        return this.currentPage > 0;
    }

    hasNextPage() {
        return this.currentPage + 1 < this.schema.fieldsets.length;
    }


}
